module fdm.rawFiles {

    angular.module('fdm.rawFiles', []);
}